import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService } from 'app/globals-services/globals.service';

@Component({
  selector: 'app-shared-document-upload',
  templateUrl: './shared-document-upload.component.html',
  styleUrls: ['./shared-document-upload.component.scss']
})
export class SharedDocumentUploadComponent implements OnInit {

  document: any = {
    issueDate: undefined,
    expiryDate: undefined,
    name: 'STeP Declaration Letter',
    passFail: undefined,
    comment: 'NA',
    category: 'STeP Declaration Letter',
    topic: 'STeP Declaration Letter',
    masterId: undefined,
    msdsIdentifier: undefined,
    file: null,
  };;


  alertMsgs = {};

  expiryDate;
  issueDate;

  @Input('testWater') testWater: Boolean;
  docConditionCheck: boolean = false;
  @Input('data') data;
  @Input("showCancelButton") showCancelButton = false;
  @Output("onUploadEvent") onUploadEvent = new EventEmitter<any>();

  @Input("selfDeclarationUpload") selfDeclarationUpload = false;

  constructor(
    private translateService: TranslateService,
    private http: HttpClient,
    private globalsService: GlobalsService

  ) {
    this.fetchTranslations();
    this.translateService.onLangChange.subscribe(() => {
      // this.loading = true;
      this.fetchTranslations();
    });
  }

  ngOnInit() {
    this.initDocument();


  }

  addFile(files: FileList) {
    let file: File = files[0];
    let uploadTypes = ['pdf', 'PDF'];
    let nameArray = file.name.split('.');
    let type = nameArray[nameArray.length - 1];
    if (!uploadTypes.includes(type)) {
      alert(this.alertMsgs["FILE_TYPE"]);
      this.clearContent();
    } else {
      this.document.file = file;
    }

  }

  clearContent() {
    var elements = document.getElementsByTagName("input");
    for (var ii = 0; ii < elements.length; ii++) {
      if (elements[ii].type.toLowerCase() == 'file') {
        elements[ii].value = "";
      }
    }
    this.document.file = null;
  }

  cancel() {
    this.onUploadEvent.emit(false)
  }

  upload() {

    if (this.document["name"] == "") {
      alert(this.alertMsgs["DOCUMENT_NAME"]);
    } else if (this.document["category"] == "") {
      alert(this.alertMsgs["DOCUMENT_TYPE"]);
    } else if (this.document["passFail"] === undefined && !this.isChemicalDocument()) {
      alert(this.alertMsgs["RESULT"]);
    } else if (!this.document["issueDate"]) {
      alert(this.alertMsgs["ISSUE_DATE"]);
    } else if (!this.document["file"]) {
      alert(this.alertMsgs["FILE_SELECT"]);
    } else {
      this.uploadCILDocument();
    }

  }

  uploadCILDocument() {
    let masterId = this.data.masterId;

    let formData = new FormData();
    formData.append('name', this.document['name']);
    formData.append('category', this.document['category']);

    let isNumber: boolean = /^\d+$/.test(masterId);

    if (isNumber) {
      formData.append('masterId', masterId);
      formData.append('msdsIdentifier', '');
    } else {
      formData.append('masterId', '');
      formData.append('msdsIdentifier', masterId);
    }

    formData.append('issue', this.issueDate.getTime());
    formData.append('expiry', this.expiryDate ? this.expiryDate.getTime() : '');
    formData.append('comment', this.document['comment']);
    formData.append('file', this.document['file']);

    this.globalsService.showSpinner();
    this.http
      .post<any>(
        this.globalsService.baseHref + '/uploadCILDocument',
        formData
      )
      .subscribe(
        (response) => {
          this.data.selfDeclaration = 1
          this.globalsService.hideSpinner();
          this.onUploadEvent.emit(true)
        },
        (err) => {
          this.globalsService.hideSpinner();
        }
      );

  }

  updateExpiryDate(event: MatDatepickerInputEvent<Date>) {
    let expiryDate = new Date(this.expiryDate);
    this.document['expiryDate'] = expiryDate;
  }

  updateIssueDate(event: MatDatepickerInputEvent<Date>) {
    let issueDate = new Date(this.issueDate);
    this.document['issueDate'] = issueDate;
  }

  initDocument() {
    return { issueDate: undefined, expiryDate: undefined, name: "", passFail: undefined, comment: "", category: "", topic: "", masterId: "-1", msdsIdentifier: "none", file: null };
  }

  fetchTranslations() {
    this.translateService.get("DOCUMENT_UPLOAD_COMPONENT.ALERTS").subscribe((response) => {
      this.alertMsgs = response;
    });
  }

  hasFile() {
    return this.document.file;
  }

  isChemicalDocument() {
    return (this.document.masterId != "-1" || this.document.msdsIdentifier != "none");
  }
}
